/** Tracé SVG d'une sparkline de pressions (viewBox `0 0 w h`). */
export interface BarometerSparkline {
  w: number;
  h: number;
  line: string;
  area: string;
  min: number;
  max: number;
  count: number;
}

/**
 * Sparkline des pressions live (≥ 2 points), échelle min/max locale avec une marge de 0.2 hPa.
 * `null` sous deux points. Pur (extrait de la fiche baromètre d'inside, ADR-020).
 */
export function barometerSparkline(points: readonly number[], w = 300, h = 96): BarometerSparkline | null {
  if (points.length < 2) return null;
  const min = Math.min(...points) - 0.2;
  const max = Math.max(...points) + 0.2;
  const x = (i: number) => (i / (points.length - 1)) * w;
  const y = (p: number) => h - ((p - min) / (max - min)) * h;
  const line = points.map((p, i) => `${i === 0 ? 'M' : 'L'}${x(i).toFixed(1)} ${y(p).toFixed(1)}`).join(' ');
  const area = `${line} L${w} ${h} L0 ${h} Z`;
  return { w, h, line, area, min: min + 0.2, max: max - 0.2, count: points.length };
}
